// Shared time formatter for Task Workspace activity + notes.
//
// Fixed display timezone: EST (UTC-5) year-round. Does NOT shift to EDT.
// `Etc/GMT+5` in the IANA tzdb is UTC-5 (POSIX sign reversal — the "+5"
// means "five hours west of UTC"), so Intl formats a canonical EST clock
// regardless of DST.

export function formatEstTs(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "—";
  const date = new Intl.DateTimeFormat("en-US", {
    timeZone: "Etc/GMT+5",
    month: "short",
    day: "numeric",
    year: "numeric",
  }).format(d);
  const time = new Intl.DateTimeFormat("en-US", {
    timeZone: "Etc/GMT+5",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  }).format(d);
  return `${date} · ${time} EST`;
}

// Human-readable mapping for Task Workspace audit actions. Keeps the
// activity feed readable without hard-coding the backend action codes
// across multiple places.
const TASK_ACTION_LABELS = {
  task_note_added: "added a working note",
  task_note_deleted: "deleted a working note",
  task_contact_linked: "linked a contact",
  task_contact_unlinked: "unlinked a contact",
  task_organization_linked: "linked an organization",
  task_organization_unlinked: "unlinked an organization",
  task_reference_added: "added a reference",
  task_reference_removed: "removed a reference",
  task_created: "created the task",
  task_updated: "updated the task",
  task_deleted: "deleted the task",
};

export function formatTaskAction(action) {
  if (!action) return "updated the task";
  if (TASK_ACTION_LABELS[action]) return TASK_ACTION_LABELS[action];
  return action.replace(/^task_/, "").replace(/_/g, " ");
}
